import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API_BASE_URL from "../../config";

// Fetch all categories
export const fetchCategoriesThunk = createAsyncThunk(
  "category/fetchAll",
  async () => {
    const response = await axios.get(
      `${API_BASE_URL}/classes/get-type`
    ); // your GET API
    return response.data;
  }
);

// Optionally, you can create a POST thunk as well
export const createCategoryThunk = createAsyncThunk(
  "category/create",
  async (categoryData) => {
    const response = await axios.post(
      `${API_BASE_URL}/classes/create-type`,
      categoryData
    );
    return response.data;
  }
);
export const updateCategoryThunk = createAsyncThunk(
  "category/update",
  async (categoryData) => {
    console.log("Updating category with data:", categoryData);
    const response = await axios.put(
      `${API_BASE_URL}/classes/update-type/${categoryData.type_id}`,
      categoryData
    );
    return response.data;
  }
);
export const getTypeMappingThunk = createAsyncThunk(
  "category/getMappedType",
  async (categoryData) => {
    console.log("mapped:", categoryData);
    const response = await axios.get(
      `${API_BASE_URL}/classes/get-mapped-type/${categoryData.type_id}`   
    );
    return response.data;
  }
);
